import GiaiQuyetDonPage from './GiaiQuyetDonPage.jsx';
import XuLyGiaiQuyetDonPage from './XuLyGiaiQuyetDonPage.jsx';
import TuGiaiQuyetDonPage from './TuGiaiQuyetDonPage.jsx';
import TruongPhongThuHoiPage from './TruongPhongThuHoiPage.jsx';

export {
  GiaiQuyetDonPage,
  XuLyGiaiQuyetDonPage,
  TuGiaiQuyetDonPage,
  TruongPhongThuHoiPage
}


// WEBPACK FOOTER //
// ./src/components/pages/giai-quyet-don/index.js